import { useState, useRef } from "react";
import { Wheel } from "react-custom-roulette";
import { Box, Button, Container, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import CustomBreadcrumbs from "src/components/custom-breadcrumbs";
import { useSettingsContext } from "src/components/settings";
import { useBoolean } from "src/hooks/use-boolean";
import Iconify from "src/components/iconify";

const participants = [
    "Alice", "Bob", "Charlie", "David", "Eve",
    "Frank", "Grace", "Hannah", "Isaac", "Jack"
];

const data = participants.map((name, index) => ({ option: name, id: index }));

const GiveawayLiveDraw = () => {
    
    const spinning = useBoolean();
    const openDialog = useBoolean();
    const [prizeIndex, setPrizeIndex] = useState(null);
    const [winner, setWinner] = useState(null);
    const spinSound = useRef(new Audio("https://www.fesliyanstudios.com/play-mp3/438"));
    const settings = useSettingsContext();

    const startDraw = () => {
        if (spinning.value) return;

        const randomIndex = Math.floor(Math.random() * participants.length);
        setPrizeIndex(randomIndex);
        spinning.onTrue();
        setWinner(null);

        spinSound.current.play();
    };
    const handleStopSpinning = () => {
        spinning.onFalse();
        const selectedWinner = participants[prizeIndex];
        setWinner(selectedWinner);
        openDialog.onTrue();

        spinSound.current.pause();
        spinSound.current.currentTime = 0;
    };

    return (
        <Container maxWidth={settings.themeStretch ? false : "xl"}>
            <CustomBreadcrumbs
                heading="Giveaway Live Draw - Wheel"
                links={[
                    { name: "Dashboard", href: "/dashboard" },
                    { name: "Giveaway", href: "/dashboard/giveaway" },
                    { name: "Live Draw" }
                ]}
                sx={{ pb: 2 }}
            />

            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', mt: 4 }}>
                <Typography variant="h4" sx={{ fontWeight: "bold", mb: 2, textShadow: "1px 1px 4px rgba(0,0,0,0.3)" }}>
                    {winner ? `` : "Spin the Wheel!"}
                </Typography>

                <Wheel
                    mustStartSpinning={spinning.value}
                    prizeNumber={prizeIndex}
                    data={data}
                    onStopSpinning={handleStopSpinning}
                    backgroundColors={["#FF5722", "#4CAF50", "#1976D2", "#FFC107"]}
                    textColors={["#FFFFFF"]}
                />
                <Button
                    variant="contained"
                    color="primary"
                    sx={{
                        mt: 5,
                        fontSize: "1.2rem",
                        padding: "12px 30px",
                        borderRadius: "50px",
                        fontWeight: "bold",
                        color: "white",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                        
                    }}
                    onClick={startDraw}
                    disabled={spinning.value}
                >
                    {spinning.value ? "Spinning..." : "Spin the Wheel!"}
                </Button>
            </Box>

            <Dialog open={openDialog.value} onClose={() => openDialog.onFalse()} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ fontWeight: "bold", textAlign: "center", fontSize: "2rem", }}>
                    <img src="/assets/congratulationIcon.png" alt="hello" />
                    <Typography color={"primary"} variant="h4" sx={{ textShadow: "1px 1px 4px rgba(0,0,0,0.3)" }}>Congratulations</Typography>
                </DialogTitle>
                <DialogContent sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Box
                    >
                        <Typography variant="h4" color={"primary"} sx={{ fontWeight: "bold", textShadow: "1px 1px 4px rgba(0,0,0,0.3)", textAlign: "center" }}>
                            <Iconify icon="solar:cup-outline" color="primary" width={30} height={30} /> {winner}  <Iconify icon="solar:cup-outline" color="primary" width={30} height={30} />
                        </Typography>
                        <Typography variant="subtitle1" sx={{ opacity: 0.9, mt: 1 }}>
                            You are the lucky winner!
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button fullWidth
                        color="primary"
                        sx={{ paddingY: 2 }}
                        onClick={() => openDialog.onFalse()}
                        variant="contained"
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

        </Container>
    );
};


export default GiveawayLiveDraw;